export const wlaAnalyticsLoader = {
  chartAnalytics: 'chartAnalytics',
  detailAnalytics: 'detailAnalytics',
  barAnalytics: 'barAnalytics',
  structuralAnalytics: 'structuralAnalytics',
  personelAnalytics: 'personelAnalytics',
  processAnalytics: 'processAnalytics',
  detailOrgStructure: 'detailOrgStructure',
  detailPersonnel: 'detailPersonnel',
  detailWlaProcess: 'detailWlaProcess',
  detailWlaListProcess: 'detailWlaListProcess',
};

export const initialStateAnalytics = {
  chartAnalytics: true,
  detailAnalytics: true,
  barAnalytics: true,
  structuralAnalytics: true,
  personelAnalytics: true,
  processAnalytics: true,
  detailOrgStructure: true,
  detailPersonnel: true,
  detailWlaProcess: true,
  detailWlaListProcess: true,
};
